module.exports = __webpack_public_path__ + "img/Belgium.d738d1b8.svg";